import styled from "styled-components";

const StyledCheckbox = styled.label`
  width: 100%;
  font-size: var(--font-size-16);
  input {
    width: 20px;
    height: 20px;
  }
  @media (min-width: 768px) {
    width: 95%;
  }
`;
export default function CheckboxField({ children = <></>, ...props }) {
  return (
    <StyledCheckbox>
      {" "}
      <label className="checkbox-input">
        {" "}
        <input type="checkbox" {...props} /> {children}{" "}
      </label>{" "}
    </StyledCheckbox>
  );
}
